module.exports = {
	"de": {
		"conversation": {
			"widget": {
				"title": "Chatten Sie mit uns",
				"subtitle": ""
			}
		}
	}
};